var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { computedFrom } from "aurelia-binding";
import { LookupValueRequest, LookupValueQuery } from "../../../../../models/lookups/lookup.models";
import moment from "moment";
import * as Enumerable from "linq";
var SweepstakeBasicMeta = /** @class */ (function (_super) {
    __extends(SweepstakeBasicMeta, _super);
    function SweepstakeBasicMeta(notificationService, i18N, tokenClient, dialogClientService, lookupClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClient = tokenClient;
        _this.dialogClientService = dialogClientService;
        _this.lookupClientService = lookupClientService;
        _this.sweepstakeCategories = [];
        _this.hours = Enumerable.range(0, 24)
            .select(function (x) {
            return {
                name: _this.padWithZero(x),
                value: x
            };
        })
            .toArray();
        _this.minutes = Enumerable.range(0, 60)
            .select(function (x) {
            return {
                name: _this.padWithZero(x),
                value: x
            };
        })
            .toArray();
        return _this;
    }
    Object.defineProperty(SweepstakeBasicMeta.prototype, "isPromotion", {
        get: function () {
            return this._isPromotion;
        },
        set: function (value) {
            this._isPromotion = value;
            this.item.updateBrandSweepstake.isPromotion = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeBasicMeta.prototype, "redirectUrl", {
        get: function () {
            return this._redirectUrl;
        },
        set: function (value) {
            this._redirectUrl = value;
            this.item.updateBrandSweepstake.redirectUrl = this._redirectUrl;
        },
        enumerable: false,
        configurable: true
    });
    SweepstakeBasicMeta.prototype.onActivated = function () {
        this._redirectUrl = this.item.navigationInfo && this.item.navigationInfo.redirectUrl ? this.item.navigationInfo.redirectUrl : "";
        this._isPromotion = this.item.navigationInfo && this.item.navigationInfo.isPromotion ? this.item.navigationInfo.isPromotion : false;
        this.item.updateBrandSweepstake = {
            hasChanges: true,
            sweepstakeId: this.item.sweepstakeId,
            brandId: this.item.navigationInfo ? this.item.navigationInfo.brandId : null
        };
        this.loadTimeZones();
    };
    SweepstakeBasicMeta.prototype.attached = function () {
        this.getAllSweepstakeCategories();
    };
    Object.defineProperty(SweepstakeBasicMeta.prototype, "showManageTemplate", {
        get: function () {
            return (this.item.navigationInfo && this.item.navigationInfo.brandId) // is brand
                || (this.item.navigationInfo && !this.item.navigationInfo.operatorId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeBasicMeta.prototype, "isReadonly", {
        get: function () {
            if (this.item && !this.item.navigationInfo)
                return false;
            else
                return this.item.navigationInfo.operatorId || this.item.navigationInfo.brandId && this.item.sweepstakeId > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeBasicMeta.prototype, "isBrandAdmin", {
        get: function () {
            return this.tokenClient.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SweepstakeBasicMeta.prototype, "isAdmin", {
        get: function () {
            return this.tokenClient.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    SweepstakeBasicMeta.prototype.createSweepstakeDraw = function () {
        if (!this.item.sweepstakeId) {
            return;
        }
        require("../dialogs/create-sweepstake-draw"); // this is to show delete modal dialog
        this.dialogClientService.show(DialogServiceConstants.URLs.CreateSweepstakeDraw, this.item);
    };
    SweepstakeBasicMeta.prototype.isCategoryChecked = function (category) {
        var _this = this;
        return Enumerable.from(this.item.categoryLinks)
            .any(function (x) { return x.sweepstakeCategoryId == category.id && x.sweepstakeId == _this.item.sweepstakeId; });
    };
    SweepstakeBasicMeta.prototype.assignCategory = function (event, category) {
        var isChecked = event.detail.value;
        if (isChecked) {
            this.item.categoryLinks.push({ sweepstakeCategoryId: category.id, sweepstakeId: this.item.sweepstakeId });
            return;
        }
        var sweepstakeCategory = Enumerable.from(this.item.categoryLinks).firstOrDefault(function (x) { return x.sweepstakeCategoryId == category.id; });
        if (!sweepstakeCategory)
            return;
        var sweepstakeCategoryIndex = this.item.categoryLinks.indexOf(sweepstakeCategory);
        this.item.categoryLinks.splice(sweepstakeCategoryIndex, 1);
    };
    SweepstakeBasicMeta.prototype.getAllSweepstakeCategories = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.sweepstakeCategories;
        return this.lookupClientService.getLookup(request).then(function (x) {
            _this.sweepstakeCategories = x.values;
        });
    };
    SweepstakeBasicMeta.prototype.loadTimeZones = function () {
        var time = moment;
        this.timeZoneLookupValues = time.tz.names().map(function (name) {
            return {
                id: name,
                name: name
            };
        });
    };
    SweepstakeBasicMeta.prototype.padWithZero = function (x) {
        return x > 9 ? ("" + x) : ("0" + x);
    };
    __decorate([
        computedFrom("_isPromotion"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SweepstakeBasicMeta.prototype, "isPromotion", null);
    __decorate([
        computedFrom("_redirectUrl"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SweepstakeBasicMeta.prototype, "redirectUrl", null);
    SweepstakeBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            TokenClient,
            DialogClientService,
            LookupClientService])
    ], SweepstakeBasicMeta);
    return SweepstakeBasicMeta;
}(ChildComponent));
export { SweepstakeBasicMeta };
